import { config } from '@/pageConfig/faq/de/en';
import { FaqPageTemplate } from '@/pageTemplate/FaqPageTemplate';
import { useAnalyticsContext } from '@lemonade-hq/nuiza';
import { useEffect } from 'react';

export default function HomePage() {
  const { trackEvent } = useAnalyticsContext();
  // biome-ignore lint/correctness/useExhaustiveDependencies: we just one it on load so no need to add it as a dependency
  useEffect(() => {
    trackEvent('faq_page.viewed', {
      locale: 'en-DE',
    });
  }, []);

  return <FaqPageTemplate config={config} locale="en-DE" />;
}
